const UPDATE_SUSPECTS_LIST = 'UPDATE_SUSPECTS_LIST'
const PRELOAD_IMAGES_SUCCESS = 'PRELOAD_IMAGES_SUCCESS'
const PRELOAD_IMAGES = 'PRELOAD_IMAGES'
const INCREMENT_UNREAD_ACTIVE_CLUES = 'INCREMENT_UNREAD_ACTIVE_CLUES'
const DECREMENT_UNREAD_ACTIVE_CLUES = 'DECREMENT_UNREAD_ACTIVE_CLUES'
const TOGGLE_INTRO = 'TOGGLE_INTRO'
const INTRO_FINISHED = 'INTRO_FINISHED'
const SET_INTRO = 'SET_INTRO'
const SET_SUSPECTS = 'SET_SUSPECTS'
const SET_SUSPECT = 'SET_SUSPECT'
const SET_SUSPECT_CLUE = 'SET_SUSPECT_CLUE'
const SET_RESTAURANT = 'SET_RESTAURANT'
const SET_RESTAURANTS = 'SET_RESTAURANTS'
const SET_RESTAURANT_VIEW = 'SET_RESTAURANT_VIEW'
const ADD_URL_TO_PRELOADED_RECORD = 'ADD_URL_TO_PRELOADED_RECORD'
const SET_GRAPHQL_TOUR = 'SET_GRAPHQL_TOUR'
const SET_ERROR = "SET_ERROR"
const SETUP_TOUR = 'SETUP_TOUR'
const SET_UNREAD_ACTIVE_CLUES = 'SET_UNREAD_ACTIVE_CLUES'
const SERVICE_WORKER_ACTIVATED = 'SERVICE_WORKER_ACTIVATED'
const CONTENT_CACHED = 'CONTENT_CACHED'
const SERVICE_WORKER_UPDATED = 'SERVICE_WORKER_UPDATED'
const APPLICATION_OFFLINE = 'APPLICATION_OFFLINE'
const END_TOUR = 'END_TOUR'
const PRELOAD_IMAGE_SUCCESS = 'PRELOAD_IMAGE_SUCCESS'
const FINISH_SETUP_AND_PRELOADING = 'FINISH_SETUP_AND_PRELOADING'
const SET_SETUP_AND_PRELOADING_COMPLETE = 'SET_SETUP_AND_PRELOADING_COMPLETE'

import graphql from '../../../utils/graphql'

const {
    doQuery,
    doQuery2,
    queries
} = graphql

import {
    Cache
} from 'aws-amplify'
const cacheConfig = {
    keyPrefix: 'fdi-tourmodule-'
};
const FDILocalStorage = Cache.createInstance(cacheConfig);

import {
    get
} from 'lodash'

const state = {

    fetchingTour: false,
    fetchingAttempts: 0,
    setupFinished: false,
    preloadingImages: false,
    preloadImagesSuccess: false,
    error: null,
    userTourAvailable: false,
    userTour: {
        suspects: {},
        restaurants: {}
    },
    currentRestaurantIndex: 0,
    currentStepIndex: 0,
    currentDialogIndex: 0,
    currentRestaurant: {
        views: {}
    },
    currentRestaurantStepNumber: null,
    userTourRestaurantNumber: null,
    currentStep: {},
    restaurantIconType: null,
    currentTourPlacement: [0, 0],
    currentPosition: [0, 0, 0],
    maxTourPosition: [0, 0, 0],
    userTourOpen: false,
    totalUnreadActiveClues: 0,
    showIntro: true,
    introFinished: false,
    preloadedUrlRecord: [],
    graphqlResponse: {},
    restaurants: {},
    suspects: {},
    clues: {},
    views: {},
    serviceWorkerActivated: null,
    serviceWorkerUpdated: false,
    applicationOffline: false,
    contentCached: false,
    setupAndPreloadingComplete: null
}

function comparePositions(current, availAfter) {

    let firstGreater = current[0] >= availAfter.aaRestIndex
    let secondGreater = current[1] >= availAfter.aaViewIndex
    let thirdGreater = current[2] >= availAfter.aaDialogIndex

    if (firstGreater && secondGreater && thirdGreater) {
        return true
    }
}

const mutations = {

    FETCHING_USER_TOUR(state) {
        state.fetchingTour = true
        state.fetchingAttempts++
    },

    FETCHING_USER_TOUR_SUCCESS(state, userTour) {
        state.fetchingTour = false
        state.fetchingAttempts = 0
        state.userTour = userTour
        setTimeout(() => {
            state.userTourAvailable = true
        }, 5000)

    },
    FETCHING_USER_TOUR_FAILURE(state, error) {

        state.fetchingTour = false
        state.userTourAvailable = false
        state.error = error
    },
    UPDATE_CURRENT_USER_TOUR(state, userTour) {
        state.userTour = userTour
        state.currentStepIndex = 0
        state.currentRestaurantIndex = 0
    },
    SET_CURRENT_RESTAURANT(state) {

        state.currentRestaurant = state.userTour.restaurants[state.currentRestaurantIndex]
    },
    SET_CURRENT_STEP(state) {
        var currentStepIndex = state.currentStepIndex
        state.currentStep = state.currentRestaurant.views[currentStepIndex]
    },
    SET_USER_TOUR_RESTAURANT_NUMBER(state) {
        state.userTourRestaurantNumber = state.userTour.restaurants.length
    },
    SET_CURRENT_RESTAURANT_STEP_NUMBER(state) {
        state.currentRestaurantStepNumber = state.currentRestaurant.views ? state.currentRestaurant.views.length : 0
    },
    INCREMENT_CURRENT_STEP_INDEX(state) {
        state.currentStepIndex++
    },
    RESET_CURRENT_STEP_INDEX(state) {
        state.currentStepIndex = 0
    },
    SET_SPECIFIC_STEP_INDEX(state, index) {
        state.currentStepIndex = index
    },
    SET_SPECIFIC_RESTAURANT_INDEX(state, index) {
        state.currentRestaurantIndex = index
    },
    SET_SPECIFIC_DIALOG_INDEX(state, index) {
        state.currentDialogIndex = index
    },
    INCREMENT_CURRENT_RESTAURANT_INDEX(state) {
        state.currentRestaurantIndex++
    },
    DECREMENT_CURRENT_STEP_INDEX(state) {
        state.currentStepIndex--
    },
    DECREMENT_CURRENT_RESTAURANT_INDEX(state) {
        state.currentRestaurantIndex--
    },
    ACTIVATE_SUSPECT(state, suspect) {
        suspect.active = true
    },
    ACTIVATE_CLUE(state, clue) {

        clue.active = true
    },
    USER_READ_CLUE(state, clueId) {

        state.clues[clueId].read = true
    },
    UPDATE_TOUR_POSITION(state, currentPosition) {
        state.currentPosition = currentPosition
    },
    UPDATE_MAX_TOUR_POSITION(state, pos) {
        state.maxTourPosition = pos
    },
    [UPDATE_SUSPECTS_LIST]: (state, newList) => {
        state.userTour.suspects = newList
    },
    [PRELOAD_IMAGES]: (state) => {
        state.preloadingImages = true
    },
    [PRELOAD_IMAGES_SUCCESS]: (state) => {
        state.preloadingImages = false
        state.preloadImagesSuccess = true
    },
    [INCREMENT_UNREAD_ACTIVE_CLUES]: (state) => {
        state.totalUnreadActiveClues++
            FDILocalStorage.setItem('unread-active-clues', JSON.stringify(state.totalUnreadActiveClues))
    },
    [DECREMENT_UNREAD_ACTIVE_CLUES]: (state) => {
        state.totalUnreadActiveClues--
            FDILocalStorage.setItem('unread-active-clues', JSON.stringify(state.totalUnreadActiveClues))
    },
    [SET_UNREAD_ACTIVE_CLUES]: (state, num) => {
        state.totalUnreadActiveClues = num
    },
    [TOGGLE_INTRO]: (state) => {
        state.showIntro = !state.showIntro
    },
    [INTRO_FINISHED]: (state) => {
        state.introFinished = true
    },
    [SET_SUSPECTS]: (state, suspectList) => {
        state.userTour.suspects = suspectList
    },
    [ADD_URL_TO_PRELOADED_RECORD]: (state, url) => {
        state.preloadedUrlRecord = [...state.preloadedUrlRecord, url]
    },
    [SET_GRAPHQL_TOUR]: (state, response) => {
        state.graphlResponse = response
    },
    [SET_ERROR]: (state, err) => {
        state.error = err
    },
    [SET_RESTAURANT]: (state, payload) => {
        state.restaurants[payload.key] = payload.restaurant
    },
    [SET_SUSPECTS]: (state, suspects) => {
        state.userTour.suspects = suspects
    },
    [SET_SUSPECT]: (state, suspect) => {
        state.suspects[suspect.id] = suspect
    },
    [SET_SUSPECT_CLUE]: (state, clue) => {
        state.clues[clue.id] = clue
    },
    [SET_RESTAURANT_VIEW]: (state, view) => {
        state.views[view.id] = view
    },
    [SETUP_TOUR]: (state, bool) => {
        state.setupFinished = bool
    },
    [SERVICE_WORKER_ACTIVATED]: (state, bool) => {
        state.serviceWorkerActivated = bool
    },
    [CONTENT_CACHED]: (state, bool) => {
        state.contentCached = bool
    },
    [SERVICE_WORKER_UPDATED]: (state, bool) => {
        state.serviceWorkerUpdated = bool
    },
    [APPLICATION_OFFLINE]: (state, bool) => {
        state.applicationOffline = bool
    },
    [FINISH_SETUP_AND_PRELOADING]: (state) => {
        state.setupAndPreloadingComplete = true
        FDILocalStorage.setItem('setup-preloading-complete', JSON.stringify(true))
    },
    [SET_SETUP_AND_PRELOADING_COMPLETE]: (state, bool) => {
        state.setupAndPreloadingComplete = bool
        FDILocalStorage.setItem('setup-preloading-complete', JSON.stringify(bool))
    },
    [SET_INTRO]: (state, bool) => {
        state.introFinished = bool
    }
}

const actions = {
    clearTourCache() {
        FDILocalStorage.clear()
    },
    async serviceWorkerActivated({
        commit
    }, bool) {
        commit(SERVICE_WORKER_ACTIVATED, bool)
    },
    async contentCached({
        commit
    }, bool) {
        commit(CONTENT_CACHED, bool)
    },
    async serviceWorkerUpdated({
        commit
    }, bool) {
        commit(SERVICE_WORKER_UPDATED, bool)
    },
    async applicationOffline({
        commit
    }, bool) {
        commit(APPLICATION_OFFLINE, bool)
    },
    async updateImageCompressionQuery({}, view) {
        switch (view.viewType) {
            case 1:
            case 3:
            case 5:
            case 6:
            case 8:
                view.url.url = view.url.url + '?auto=compression'
                break;
            case 2:
                break;
            case 4:
            case 7:
                view.dialogUrls.forEach(url => {
                    url.url = url.url + '?auto=compression'
                })
                break;
                // case 9:
                //   console.log('working on it')
        }
    },
    async setupTour({
        commit,
        dispatch,
        state
    }) {
        try {
            await dispatch('setRestaurantData')
            commit('SET_USER_TOUR_RESTAURANT_NUMBER')
            await dispatch('setInitialPosition')
            commit('SET_CURRENT_RESTAURANT')
            commit('SET_CURRENT_RESTAURANT_STEP_NUMBER')
            commit('SET_CURRENT_STEP')
            await dispatch('setInitialSuspectData')
            commit(SETUP_TOUR, true)
        } catch (err) {
            console.log(err)
        }
    },
    async fetchAllTours({
        commit,
        dispatch
    }, params) {
        commit('FETCHING_USER_TOUR')
        let response
        try {
            if (params.serviceWorker) {
                response = await doQuery2(queries.productionTour, {
                    tourAbbrv: params.tourAbbrv,
                    version: params.version
                })
                commit('FETCHING_USER_TOUR_SUCCESS', response.data.productionTour.tour)
                console.log('sw', response.data.productionTour.tour)
            } else {
                response = await doQuery(queries.productionTour, {
                    tourAbbrv: params.tourAbbrv,
                    version: params.version
                })
                commit('FETCHING_USER_TOUR_SUCCESS', response.data.productionTour.tour)
            }
        } catch (err) {
            commit('FETCHING_USER_TOUR_FAILURE', err)
        }
    },
    async setRestaurantData({
        commit,
        dispatch,
        state
    }) {
        let restaurants = state.userTour.restaurants
        for (let r in restaurants) {
            let restaurant = restaurants[r]
            commit(SET_RESTAURANT, {
                key: parseInt(r) + 1,
                restaurant
            })
            commit(SET_RESTAURANT, {
                key: restaurant.id,
                restaurant
            })
            let views = restaurant.views
            await dispatch('setViewData', views)
        }
    },
    async setViewData({
        dispatch,
        commit,
        state
    }, views) {
        for (let v in views) {
            commit(SET_RESTAURANT_VIEW, views[v])
            dispatch('updateImageCompressionQuery', views[v])
        }
    },
    setInitialPosition({
        commit,
        dispatch,
        state
    }) {
        return new Promise(async(resolve, reject) => {
            //FDILocalStorage.clear()
            //console.log('Setting initial position')
            try {
                var ri = FDILocalStorage.getItem('restaurantIndex', {
                    callback: () => 0
                })
                var si = FDILocalStorage.getItem('stepIndex', {
                    callback: () => 0
                })
                var di = FDILocalStorage.getItem('dialogIndex', {
                    callback: () => 0
                })
                var maxPosition = JSON.parse(FDILocalStorage.getItem('maxPosition', {
                    callback: () => JSON.stringify([0, 0, 0])
                }))
                var userUnreadClues = JSON.parse(FDILocalStorage.getItem('unread-active-clues', {
                    callback: () => 0
                }))
                commit(SET_UNREAD_ACTIVE_CLUES, userUnreadClues)
                commit('SET_SPECIFIC_RESTAURANT_INDEX', JSON.parse(ri))
                commit('SET_SPECIFIC_STEP_INDEX', JSON.parse(si))
                commit('SET_SPECIFIC_DIALOG_INDEX', JSON.parse(di))
                commit('UPDATE_MAX_TOUR_POSITION', maxPosition)
                commit('UPDATE_TOUR_POSITION', [ri, si, di])
                resolve()
            } catch (err) {
                commit(SET_ERROR, err)
                reject(err)
            }
        })
    },
    updateTourPosition({
        commit,
        state,
        dispatch
    }) {
        return new Promise((resolve, reject) => {
            let currentPosition = [state.currentRestaurantIndex, state.currentStepIndex, state.currentDialogIndex]
            commit('UPDATE_TOUR_POSITION', currentPosition)
            dispatch('updatePositionInLocalStorage', currentPosition)
            dispatch('updateMaxTourPosition')
            resolve()
        })
    },
    updatePositionInLocalStorage(context, currentPosition) {
        FDILocalStorage.setItem('restaurantIndex', JSON.stringify(currentPosition[0]), {
            priority: 1
        });
        FDILocalStorage.setItem('stepIndex', JSON.stringify(currentPosition[1]), {
            priority: 1
        });
        FDILocalStorage.setItem('dialogIndex', JSON.stringify(currentPosition[2]), {
            priority: 1
        });
    },
    updateMaxTourPosition({
        commit,
        state
    }) {
        if ((state.currentPosition[0] > state.maxTourPosition[0]) || (state.currentPosition[1] > state.maxTourPosition[1]) || (state.currentPosition[2] > state.maxTourPosition[2])) {
            commit('UPDATE_MAX_TOUR_POSITION', state.currentPosition)
            FDILocalStorage.setItem('maxPosition', JSON.stringify(state.maxTourPosition), {
                priority: 1
            });
        }
    },
    async preloadRestaurantObject({
        dispatch
    }, restaurant) {
        const views = restaurant.views
        const restViewsPreloadArray = await views.map(async(view, i) => {
            if (view.url) {
                return await dispatch('preloadView', view.url.url)
            }
            if (view.dialogUrls) {
                const dialogUrlsPreload = await view.dialogUrls.map(async dUrl => {
                    return await dispatch('preloadView', dUrl.url)
                })
                return Promise.all(dialogUrlsPreload)
            }
            if (view.viewType === 2 && view.hints) {
                if (view.hints.length > 0) {
                    const hintsResults = await view.hints.map(async hint => {
                        if (hint.type === 2) {
                            return await dispatch('preloadView', hint.url.url)
                        } else {
                            return "NA"
                        }
                    })
                    return Promise.all(hintsResults)
                } else {
                    return "NA"
                }
            }
            return "NA"
        })
        return Promise.all(restViewsPreloadArray)
    },
    async preloadView({
        state,
        dispatch,
        commit
    }, url) {
        return new Promise((resolve, reject) => {
            var img = new Image();
            img.onload = () => {
                dispatch('addUrlToPreloadedRecord', url)
                resolve({
                    url: url,
                    ok: true
                })
            }
            img.onerror = () => {
                resolve({
                    url: url,
                    ok: false
                })
            }
            img.src = url;
        })
    },
    preloadRestaurantImagesAction({
        commit,
        state
    }, restaurantIndex) {
        preloadTourViewsForCache(state.userTour, restaurantIndex)
    },
    async addUrlToPreloadedRecord({
        commit
    }, url) {
        commit(ADD_URL_TO_PRELOADED_RECORD, url)
    },
    async preloadAllTourData({
        commit,
        state,
        dispatch
    }) {
        commit(PRELOAD_IMAGES)
        const suspectsImagePreload = await state.userTour.suspects.map(async(sus, i) => {
            const main = await dispatch('preloadView', sus.view.url)
            const mugshot = await dispatch('preloadView', sus.enlargedMugshot.url)
            return {
                main,
                mugshot
            }
        })
        const restaurantPreloadArray = await state.userTour.restaurants.map(async(restaurant, i) => {
            return await dispatch('preloadRestaurantObject', restaurant)
        })
        Promise.all([Promise.all(suspectsImagePreload), Promise.all(restaurantPreloadArray)])
            .then(res => {
                commit(PRELOAD_IMAGES_SUCCESS)
                dispatch('compareCacheToUrlRecord')
            })
    },
    async compareCacheToUrlRecord({}) {
        caches.open('Fooddoneit-tourimages-V1')
            .then(function(cache) {
                cache.keys()
                    .then(key => {})
            })
    },
    async updateSuspectImageCompressionQuery({
        state
    }) {
        state.userTour.suspects.forEach(suspect => {
            suspect.enlargedMugshot.url = suspect.enlargedMugshot.url + '?auto=compression'
            suspect.view.url = suspect.view.url + '?auto=compression'
        })
    },
    async setInitialSuspectData({
        state,
        commit,
        dispatch
    }) {
        return new Promise(async(resolve, reject) => {
            await dispatch('updateSuspectImageCompressionQuery')
            var suspects = state.userTour.suspects.map((suspect, i) => {
                return JSON.parse(FDILocalStorage.getItem(`suspect-${suspect.id}`, {
                    callback: () => JSON.stringify(suspect)
                }))
            })
            commit(SET_SUSPECTS, suspects)
            for (let i in suspects) {
                var suspect = suspects[i]
                await dispatch("setInitialSuspect", suspect)
            }
            resolve()
        })
    },
    async setInitialSuspect({
        state,
        commit
    }, suspect) {
        return new Promise((resolve, reject) => {
            commit(SET_SUSPECT, suspect)
            for (let c in suspect.clues) {
                var clue = suspect.clues[c]
                commit(SET_SUSPECT_CLUE, clue)
            }
            resolve()
        })
    },
    checkViewsForHalfwayPoint({
        state,
        commit,
        dispatch
    }) {
        if ((state.currentStepIndex >= Math.floor(state.currentRestaurantStepNumber / 2)) && (state.currentRestaurantIndex !== state.userTourRestaurantNumber)) {
            dispatch('preloadRestaurantImagesAction', state.currentRestaurantIndex + 1)
        }
    },
    navigateToPreviousRestaurant({
        commit,
        dispatch
    }, index) {
        commit('SET_SPECIFIC_RESTAURANT_INDEX', index)
        commit('SET_CURRENT_RESTAURANT')
        commit('SET_CURRENT_RESTAURANT_STEP_NUMBER')
        commit('RESET_CURRENT_STEP_INDEX')
        commit('SET_CURRENT_STEP')
        dispatch('updateTourPosition')
    },
    updateSuspectCache({
        state,
        commit
    }, suspect) {
        FDILocalStorage.setItem(`suspect-${suspect.id}`, JSON.stringify(suspect))
    },
    async updateActiveSuspects({
        commit,
        state,
        dispatch
    }) {
        return new Promise(async(resolve, reject) => {
            try {
                var suspects = state.suspects
                for (let z in suspects) {
                    let suspect = suspects[z]
                    if (suspect.active) {
                        await dispatch('updateActiveClues', suspect)
                        dispatch('updateSuspectCache', suspect)
                    } else {
                        if (comparePositions(state.currentPosition, suspect.availableAfter /*{aaRestIndex: 1, aaViewIndex: 1}*/ )) {
                            commit('ACTIVATE_SUSPECT', suspect)
                            await dispatch('updateActiveClues', suspect)
                            dispatch('updateSuspectCache', suspect)
                        }
                    }
                }
                resolve()
            } catch (err) {
                reject(err)
            }
        })
    },
    finishSetupAndPreloading({
        commit
    }) {
        commit(FINISH_SETUP_AND_PRELOADING)
    },
    setInitialSetupAndPreloading({
        commit
    }) {
        return new Promise(async(resolve) => {
            var setupAndPreloadingComplete = await JSON.parse(FDILocalStorage.getItem('setup-preloading-complete', {
                callback: () => false
            }))
            commit(SET_SETUP_AND_PRELOADING_COMPLETE, setupAndPreloadingComplete)
            resolve({
                ok: true
            })
        })
    },
    userReadClue({
        commit,
        state,
        dispatch
    }, params) {
        commit('USER_READ_CLUE', params.clueId)
        commit('DECREMENT_UNREAD_ACTIVE_CLUES')
        dispatch('updateSuspectCache', state.suspects[params.suspectId])
    },
    updateActiveClues({
        commit,
        state
    }, suspect) {
        return new Promise((resolve) => {
            var clues = suspect.clues
            for (let c in clues) {
                var clue = clues[c]
                if (!clue.active) {
                    if (comparePositions(state.currentPosition, clue.availableAfter /*{aaRestIndex: 1, aaViewIndex: 1}*/ )) {
                        commit('ACTIVATE_CLUE', clue)
                        commit('INCREMENT_UNREAD_ACTIVE_CLUES')
                    }
                }
            }
            resolve()
        })
    },
    endOfTour({
        commit
    }) {
        commit(END_TOUR)
    },
    setDialog({
        commit,
        dispatch
    }, index) {
        commit('SET_SPECIFIC_DIALOG_INDEX', index)
        dispatch('updateTourPosition')
        dispatch('updateActiveSuspects')
    },
    incrementStep({
        commit,
        state,
        dispatch
    }) {
        if (state.currentStepIndex === state.currentRestaurantStepNumber - 1) {
            if (state.currentRestaurantIndex === state.userTourRestaurantNumber - 1) {
                dispatch('endOfTour')
            } else {
                commit('INCREMENT_CURRENT_RESTAURANT_INDEX')
                commit('SET_CURRENT_RESTAURANT')
                commit('SET_CURRENT_RESTAURANT_STEP_NUMBER')
                commit('RESET_CURRENT_STEP_INDEX')
                commit('SET_CURRENT_STEP')
                dispatch('updateTourPosition')
                dispatch('updateActiveSuspects')
            }
        } else {
            commit('INCREMENT_CURRENT_STEP_INDEX')
            commit('SET_CURRENT_STEP')
            dispatch('updateTourPosition')
            dispatch('updateActiveSuspects')
        }
    },
    decrementStep({
        commit,
        state,
        dispatch
    }) {
        if (state.currentStepIndex === 0) {
            if (state.currentRestaurantIndex === 0) {
                // TODO BEGINNING OF TOUR
                //------------------------------------
            } else {
                commit("DECREMENT_CURRENT_RESTAURANT_INDEX")
                commit('SET_CURRENT_RESTAURANT')
                commit('SET_CURRENT_RESTAURANT_STEP_NUMBER')
                commit('SET_SPECIFIC_STEP_INDEX', state.currentRestaurantStepNumber - 1)
                commit('SET_CURRENT_STEP')
                dispatch('updateTourPosition')
            }
        } else {
            commit('DECREMENT_CURRENT_STEP_INDEX')
            commit('SET_CURRENT_STEP')
            dispatch('updateTourPosition')
        }
    },
    updateCurrentRestaurant({
        commit
    }, restaurantIndex) {
        commit('SET_SPECIFIC_RESTAURANT_INDEX', restaurantIndex)
        commit('SET_CURRENT_RESTAURANT')
        commit('SET_CURRENT_RESTAURANT_STEP_NUMBER')
    },
    updateCurrentRestaurantStep({
        commit
    }, stepIndex) {
        commit('SET_SPECIFIC_STEP_INDEX', stepIndex)
        commit('SET_CURRENT_STEP')
    },
    updateCurrentDialog({
        commit
    }, dialogIndex) {
        commit('SET_SPECIFIC_DIALOG_INDEX', dialogIndex)
    },
    restartTour({
        dispatch,
        commit
    }) {
        return new Promise((resolve, reject) => {
            commit('SET_SPECIFIC_RESTAURANT_INDEX', 0)
            commit('SET_CURRENT_RESTAURANT')
            commit('SET_CURRENT_RESTAURANT_STEP_NUMBER')
            commit('SET_SPECIFIC_STEP_INDEX', 0)
            commit('SET_CURRENT_STEP')
            commit('SET_SPECIFIC_DIALOG_INDEX', 0)
            dispatch('updateTourPosition')
            resolve()
        })
    },
    navigateToMaxPosition({
        dispatch,
        commit,
        state
    }) {
        return new Promise(resolve => {
            var restIndex = state.maxTourPosition[0]
            var stepIndex = state.maxTourPosition[1]
            var dialogIndex = state.maxTourPosition[2]
            commit('SET_SPECIFIC_RESTAURANT_INDEX', restIndex)
            commit('SET_CURRENT_RESTAURANT')
            commit('SET_CURRENT_RESTAURANT_STEP_NUMBER')
            commit('SET_SPECIFIC_STEP_INDEX', stepIndex)
            commit('SET_CURRENT_STEP')
            commit('SET_SPECIFIC_DIALOG_INDEX', dialogIndex)
            dispatch('updateTourPosition')
            resolve()
        })
    },
    activateSuspect({
        commit
    }, name) {
        commit('ACTIVATE_SUSPECT', name)
    },
    activateClue({
        commit
    }, name, clueId) {
        commit('ACTIVATE_CLUE', name, clueId)
    },
    readClue({
        commit
    }, name, clueId) {
        commit('USER_READ_CLUE', {
            name: name,
            clueId: clueId
        })
    },
    toggleIntro({
        commit
    }) {
        commit(TOGGLE_INTRO)
    },
    introFinished({
        commit
    }) {
        commit(INTRO_FINISHED)
    },
    setIntro({
        commit
    }, bool) {
        commit(SET_INTRO, bool)
        FDILocalStorage.setItem('intro-finished', bool)
    },
    async setInitialIntro({
        commit
    }) {
        var intro = await JSON.parse(FDILocalStorage.getItem('intro-finished', {
            callback: () => false
        }))
        commit(SET_INTRO, intro)
    }
}

const getters = {
    userTour: state => state.userTour,
    restaurantListLength: state => state.userTour.restaurants.length,
    userTourAvailable: state => state.userTourAvailable,
    userTourId: state => state.userTour.tourId,
    currentRestaurant: state => state.currentRestaurant,
    currentStep: state => state.currentStep,
    currentRestaurantIndex: state => state.currentRestaurantIndex,
    currentStepIndex: state => state.currentStepIndex,
    tourLocation: state => state.userTour.location,
    currentRestaurantStepObjects: state => state.currentRestaurant ? state.currentRestaurant.views : [],
    currentTourPlacement: state => ({
        restaurant: state.currentRestaurantIndex,
        step: state.currentStepIndex,
        dialog: state.currentDialogIndex
    }),
    restaurantIconType: (state) => (key) => state.userTour.restaurants[`${key}`].iconType,
    suspects: (state) => state.userTour ? state.userTour.suspects : [],
    restaurants: (state) => state.userTour.restaurants,
    restaurantKeys: (state) => state.userTour ? Object.keys(state.userTour.restaurants) : [],
    suspect: (state) => (name) => state.userTour ? state.userTour.suspects.find(suspect => suspect.name === name) : {},
    totalUnreadActiveClues: (state) => state.totalUnreadActiveClues,
    showIntro: state => state.showIntro,
    introFinished: (state) => state.introFinished,
    preloadingImages: (state) => state.preloadingImages,
    preloadImagesSuccess: (state) => state.preloadImagesSuccess,
    setupFinished: (state) => state.setupFinished,
    serviceWorkerActivated: (state) => state.serviceWorkerActivated,
    maxRestaurantIndex: (state) => state.maxTourPosition[0],
    setupAndPreloadingComplete: (state) => state.setupAndPreloadingComplete,
    contentCached: (state) => state.contentCached,
    tourId: state => state.userTour ? state.userTour.id : null
}

const tourModule = {
    state,
    mutations,
    actions,
    getters
}

export default tourModule;